import { FC } from "react";
import { Network, THOR, networkConfirmationTime } from "rujira.js";
import { useTranslation } from "../../i18n";

const TRANSFER_TIMES: Partial<Record<Network, string>> = {
  [THOR]: "6 seconds",
  BTC: "3 - 45 minutes",
  ETH: "25 seconds - 5 minutes",
  AVAX: "20 seconds - 2 minutes",
  BASE: "20 seconds - 3 minutes",
  BCH: "20 seconds - 9 minutes",
  BSC: "20 seconds - 3 minutes",
  DOGE: "30 seconds - 5 minutes",
  GAIA: "15 seconds - 30 minutes",
  LTC: "40 seconds - 10 minutes",
  TRON: "20 seconds - 5 minutes",
  XRP: "20 seconds - 30 minutes",
};

export const getTransferTime = (network?: Network): string | undefined => {
  if (!network) return undefined;
  if (TRANSFER_TIMES[network]) return TRANSFER_TIMES[network];

  try {
    return `${networkConfirmationTime(network)} seconds`;
  } catch {
    return undefined;
  }
};

const formatTransferTime = (
  value: string,
  secondsLabel: string,
  minutesLabel: string
) =>
  value.split(/(seconds|minutes|-)/).map((part, index) =>
    part === "-" ? (
      <span key={index}>&nbsp;-&nbsp;</span>
    ) : part === "seconds" || part === "minutes" ? (
      <span key={index} className="color-grey">
        &nbsp;{part === "seconds" ? secondsLabel : minutesLabel}
      </span>
    ) : (
      part
    )
  );

export const TransferTimeValue: FC<{ network?: Network }> = ({ network }) => {
  const { t } = useTranslation("common");
  const transferTime = getTransferTime(network);
  return transferTime
    ? formatTransferTime(transferTime, t("seconds"), t("minutes"))
    : t("na");
};

export const TransferTimeRow: FC<{
  network?: Network;
  label: string;
  tooltip: string;
  labelClassName: string;
  valueClassName: string;
  hidden?: boolean;
}> = ({
  network,
  label,
  tooltip,
  labelClassName,
  valueClassName,
  hidden = false,
}) => {
  return (
    <>
      <div
        className={labelClassName}
        style={{ visibility: hidden ? "hidden" : "visible" }}>
        <span aria-hidden="true">&bull;&nbsp;</span>
        <span
          data-tooltip-id="modal-tip"
          data-tooltip-html={`<div class="w-30 text-left">${tooltip}</div>`}
          className="has-tip no-select"
          style={{ borderBottom: "1px dotted currentColor" }}>
          {label}
        </span>
      </div>
      <div
        className={valueClassName}
        style={{ visibility: hidden ? "hidden" : "visible" }}>
        <TransferTimeValue network={network} />
      </div>
    </>
  );
};
